import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@api/base-services-axios-rtx";

import { GeoLocalizationEndpoints } from "@/shared/models/endpoints/geo-localization.endpoint";
import { createQuery } from "@/shared/helpers/create-query.helper";

import { ICreateSectorValues } from "./models/interfaces/geo-localizarion.values";

export const GeoLocalizationQueryServices = createApi({
  reducerPath: "geo-localization-services",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    getCities: builder.mutation({
      query: (values: { params: any }) => ({
        url:
          GeoLocalizationEndpoints.citiesList + createQuery(values.params),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) =>
        response.data?.map((x: any) => ({
          name: x.description,
          id: x.id
        })) as { name: string; id: any }[]
    }),
    getCountries: builder.mutation({
      query: (values: { params: ICountryParams }) => ({
        url:
          GeoLocalizationEndpoints.countriesList +
          createQuery(values.params),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) =>
        response.data?.map((x: any) => ({
          name: x.description,
          id: x.id
        })) as { name: string; id: number }[]
    }),
    getClientsCountries: builder.mutation({
      query: (values: { params: ICountryParams }) => ({
        url:
          GeoLocalizationEndpoints.clientsCountriesList +
          createQuery(values.params),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) =>
        response.data?.map((x: any) => ({ name: x.name, id: x.id })) as {
          name: string;
          id: number;
        }[]
    }),

    getSectors: builder.mutation({
      query: (values: { params: any }) => ({
        url:
          GeoLocalizationEndpoints.sectorsList +
          createQuery(values.params),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) =>
        response.data?.map((x: any) => ({
          name: x.description,
          id: x.id,
          cityName: x.city?.description ?? ""
        }))
    }),
    createSectors: builder.mutation({
      query: (values: ICreateSectorValues) => ({
        url: GeoLocalizationEndpoints.sectorsList,
        method: "POST",
        body: values.body
      }),
      transformResponse: (response: any, meta, arg) => response.data
    })
  })
});

export const {
  useGetCitiesMutation,
  useGetSectorsMutation,
  useCreateSectorsMutation,
  useGetCountriesMutation,
  useGetClientsCountriesMutation
} = GeoLocalizationQueryServices;

interface ICountryParams {
  provinceId?: number;
  cityId?: number;
  q?: string;
  perPage?: number;
}
interface ICreateSectorsParams {}
interface ICityParams {}
interface ISectorParams {}
